// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropbox[data-v-2f57754c]{outline:2px dashed #aaa;outline-offset:-10px;background:#f9f9f9;background:#eee;color:#696969;padding:10px 10px;min-height:200px;position:relative;cursor:pointer;font-family:Varela Round;margin-bottom:2rem}.input-file[data-v-2f57754c]{opacity:0;width:100%;height:200px;position:absolute;cursor:pointer}.dropbox[data-v-2f57754c]:hover{background:#ddd}.dropbox p[data-v-2f57754c]{font-size:1em;text-align:center;padding:50px 0}", ""]);
// Exports
module.exports = exports;
